<script>

import HomepageList from '@/components/subcomponents/HomepageList.vue';
import ProfilePageForm from '@/components/ProfilePage-Form.vue';
import ProfilePageView from '@/components/ProfilePage-View.vue';
import FeedbackPageForm from '@/components/FeedbackPage-Form.vue';
import FeedbackPageView from '@/components/FeedbackPage-View.vue';
import FinalQAForm from '@/components/FinalQA-Form.vue';
import AccountPage from '@/components/AccountPage.vue';
import CasePageView from '@/components/CasePage-View.vue';

export default {
  inject: ['$axios', '$_', '$DateTime'],
  props: {
    loginData: Object
  },
  data() {
    return {
      display: 'homepageList',
      patientSearching: '',
      patientSearchingIndex: 0,
      profileID: '',
      profileApproving: false,
      processFrom: '',
      profileIDCorrection: '',
      showAccountMenu: false,
      accountMenuScope: '',
      sessionIsValid: true,
      draftProfileTs: '',
      searchResults: [],
      filterForPartner: 'all',
      dirtLists: {},
      searchingInProgress: 0,
      reloadCasesFor: {
        casesIn: [],
        reloadTime: 0
      }
    }
  },
  components: {
    HomepageList,
    ProfilePageForm,
    ProfilePageView,
    FeedbackPageForm,
    FeedbackPageView,
    FinalQAForm,
    AccountPage,
    CasePageView
  },
  methods: {
    performLogout: function () {
      let vm = this;
      vm.$emit('logoutEmission', {});
    },
    showInBody: function (subComponentName) {
      let vm = this;
      vm.display = subComponentName;
      vm.showAccountMenu = false;
    },
    showAccountPage: function (subComponentName) {
      let vm = this;
      vm.accountMenuScope = subComponentName;

      vm.display = `useraccount`;
      vm.showAccountMenu = false;
    },
    recordFeedback: function (profileIdentifier) {
      let vm = this;
      vm.display = 'feedbackform';
      vm.profileID = profileIdentifier;
      vm.processFrom = 'approvedprofiles';
    },
    setPartnerFilter: function (filterText) {
      let vm = this;
      vm.filterForPartner = filterText;
    },
    updateFeedback: function (profileIdentifier) {
      let vm = this;
      vm.display = 'feedbackform';
      vm.profileID = profileIdentifier;
      vm.processFrom = 'draftfeedbacks';
    },
    correctFeedback: function (profileIdentifier) {
      let vm = this;
      vm.display = 'feedbackform';
      vm.profileID = profileIdentifier;
      vm.processFrom = 'returnedfeedbacks';
    },
    continueProfileDraft: function (profileTs) {
      let vm = this;
      vm.display = 'newProfile';
      vm.draftProfileTs = profileTs;
    },
    continueReturnedProfileDraft: function (profileTs) {
      let vm = this;
      vm.$axios
          .post('/profile/action/redraftReturnedProfile', {redraftCase: profileTs, repData: vm.currentData,}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(function () {
            vm.reloadCasesFor = {
              casesIn: [`returnedProfiles`, `draftProfiles`],
              reloadTime: vm.$DateTime.local().setZone(vm.currentData.country_tz).toUnixInteger()
            }
          });
    },
    deleteReturnedProfile: function () {
    },
    viewSubmittedProfile: function (viewingProperties) {
      let vm = this;
      vm.display = 'viewProfile';
      vm.profileID = viewingProperties.profileIdentifier;
      vm.profileApproving = viewingProperties.approvingBool;
    },
    viewSubmittedFeedback: function (profileIdentifier) {
      let vm = this;
      vm.display = 'viewFeedback';
      vm.profileID = profileIdentifier;
    },
    QASubmittedFeedback: function (profileIdentifier) {
      let vm = this;
      vm.display = 'finalQA';
      vm.profileID = profileIdentifier;
    },
    viewRejectedProfile: function (profileIdentifier) {
      let vm = this;
      vm.display = 'viewProfileRejected';
      vm.profileID = profileIdentifier;
    },
    toggleAccountMenu: function () {
      let vm = this;
      vm.showAccountMenu = !vm.showAccountMenu
    },
    updateDirtLists: function (dirtListsData) {
      let vm = this;
      vm.dirtLists = dirtListsData;
    }
  },
  mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
  },
  watch: {
    patientSearching: {
      handler() {
        let vm = this;
        if (vm.$_.trim(vm.patientSearching) === '') {
          vm.patientSearchingIndex = 0;
          vm.searchResults = [];
          vm.searchingInProgress = 0;
        } else {
          vm.searchingInProgress = 1;
          vm.$axios
              .post('/profile/action/searchCase', {
                searchString: vm.patientSearching,
                searchIndex: vm.patientSearchingIndex++,
                repData: vm.currentData,
                filterForPartner: vm.filterForPartner
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${vm.loginData.token}`
                }
              })
              .then(function (response) {
                if (response.data.success &&
                    vm.patientSearchingIndex === (parseInt(response.data.searchIndex) + 1)) {
                  if (response.data.searchResults.length === 0) {
                    vm.searchResults = [];
                    vm.searchingInProgress = 3;
                  } else {
                    vm.searchResults = response.data.searchResults;
                    vm.searchingInProgress = 2;
                  }
                } else {
                  vm.searchResults = [];
                  vm.searchingInProgress = 3;
                }
              });
        }


      },
      deep: true
    },
  }
};
</script>

<template>
  <div>
    <div class="columns is-mobile is-vcentered has-background-light" id="topNav" v-if="sessionIsValid">
      <div class="column is-one-fifth" id="addProfile">
        <button class="button is-outlined is-medium is-fullwidth" v-on:click="showInBody('newProfile')"
                v-if="display==='homepageList' && loginData.role==='Representative'">
          <font-awesome-icon :icon="['fas', 'user-plus']"/>
        </button>
        <button class="button is-outlined is-medium is-fullwidth" v-on:click="showInBody('homepageList')"
                v-if="display!=='homepageList'">
          <font-awesome-icon :icon="['fas', 'house']"/>
        </button>
      </div>
      <div class="column is-three-fifths">
        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-rounded search-input" type="text" placeholder="Search" v-model="patientSearching">
            <span class="icon is-small is-left">
               <font-awesome-icon :icon="['fas', 'magnifying-glass']"/>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-one-fifth"></div>
    </div>
    <div class="columns is-mobile is-vcentered has-background-light" id="bottomNav" v-if="sessionIsValid">
      <div class="column is-one-fifth is-hidden-mobile"></div>
      <div class="column is-one-fifth is-hidden-mobile"></div>
      <div class="column is-one-fifth is-hidden-mobile"></div>
      <div class="column is-one-fifth is-hidden-mobile"></div>
      <div
          class="column is-one-third-mobile is-one-fifth-tablet is-one-fifth-desktop is-one-fifth-widescreen is-offset-two-thirds-mobile has-text-white profile-open">
        <button class="button is-medium is-fullwidth" v-on:click="toggleAccountMenu()">
          <span class="icon">
            <font-awesome-icon :icon="['fas', 'gear']"/>
          </span>
          <span>Account</span>
        </button>
      </div>
    </div>
    <div class="columns is-mobile" id="bottomNavMenus" v-if="sessionIsValid">
      <Transition name="acctmenu">
        <div
            class="column is-one-third-mobile is-one-fifth-tablet is-one-fifth-desktop is-one-fifth-widescreen is-offset-two-thirds-mobile is-offset-four-fifths-tablet. is-offset-four-fifths-desktop is-offset-four-fifths-widescreen account-menu"
            v-if="showAccountMenu">
          <div class="has-background-dark">
            <ul class="menu-list">
              <li><a class="has-text-light" v-on:click="performLogout">Logout</a></li>
              <li><a class="has-text-light" v-on:click="showAccountPage('details')">My Details</a></li>
              <li><a class="has-text-light" v-on:click="showAccountPage('password')">Password</a></li>
            </ul>
          </div>
        </div>
      </Transition>
    </div>
    <div id="bodySection" class="landing-page-bg">
      <homepageList v-if="display==='homepageList' && sessionIsValid"
                    v-bind:loginData="loginData"
                    v-bind:searchResults="searchResults"
                    v-bind:searchingInProgress="searchingInProgress"
                    v-bind:dirtLists="dirtLists"
                    v-bind:reloadCases="reloadCasesFor"
                    v-on:filterForPartner="setPartnerFilter"
                    v-on:feedbackForProfile="recordFeedback"
                    v-on:feedbackForDraft="updateFeedback"
                    v-on:feedbackForCorrection="correctFeedback"
                    v-on:viewProfile="viewSubmittedProfile"
                    v-on:viewFeedback="viewSubmittedFeedback"
                    v-on:qaFeedback="QASubmittedFeedback"
                    v-on:viewProfileRejected="viewRejectedProfile"
                    v-on:continueDraftingProfile="continueProfileDraft"
                    v-on:continueDraftingReturnedProfile="continueReturnedProfileDraft"
                    v-on:deleteReturnedProfile="deleteReturnedProfile"
      ></homepageList>

      <ProfilePageForm v-if="display==='newProfile' && sessionIsValid"
                       v-bind:draftProfileTs="draftProfileTs"
                       v-bind:returnedProfile="false"
                       v-on:profileSaved="showInBody('homepageList')"
                       v-on:dirtLists="updateDirtLists"
      ></ProfilePageForm>

      <ProfilePageForm v-if="display==='returnedProfile' && sessionIsValid"
                       v-bind:draftProfileTs="draftProfileTs"
                       v-bind:returnedProfile="true"
                       v-on:profileSaved="showInBody('homepageList')"></ProfilePageForm>

      <ProfilePageView v-if="display==='viewProfile' && sessionIsValid && profileApproving" v-bind:profileID="profileID"
                       v-bind:profileApproving="profileApproving"
                       v-bind:loginData="loginData"
                       v-bind:dataFrom="'submittedProfile'"
                       v-on:profileSaved="showInBody('homepageList')"></ProfilePageView>

      <ProfilePageView v-if="display==='viewProfile' && sessionIsValid && !profileApproving"
                       v-bind:profileID="profileID"
                       v-bind:profileApproving="profileApproving"
                       v-bind:loginData="loginData"
                       v-bind:dataFrom="'approvedProfile'"
                       v-on:profileSaved="showInBody('homepageList')"></ProfilePageView>

      <ProfilePageView v-if="display==='viewProfileRejected' && sessionIsValid" v-bind:profileID="profileID"
                       v-bind:loginData="loginData"
                       v-bind:dataFrom="'rejectedProfile'"
                       v-on:profileSaved="showInBody('homepageList')"></ProfilePageView>

      <CasePageView v-if="display==='viewCasePage' && sessionIsValid"
                    v-bind:profileID="profileID"
                    v-bind:loginData="loginData"
                    v-bind:caseStage="'finance'"></CasePageView>

      <FeedbackPageForm v-if="display==='feedbackform' && sessionIsValid"
                        v-bind:profileID="profileID"
                        v-bind:processFrom="processFrom"
                        v-on:feedbackSaved="showInBody('homepageList')"></FeedbackPageForm>

      <FinalQAForm v-if="display==='finalQA' && sessionIsValid"
                   v-bind:profileID="profileID"
                   v-bind:loginData="loginData"
                   v-bind:dataFrom="'submittedFeedback'"
                   v-on:QASaved="showInBody('homepageList')"></FinalQAForm>

      <FeedbackPageView v-if="display==='viewFeedback' && sessionIsValid"
                        v-bind:profileID="profileID"
                        v-bind:loginData="loginData"
                        v-bind:dataFrom="'submittedFeedback'"
                        v-on:QASaved="showInBody('homepageList')"></FeedbackPageView>

      <AccountPage v-if="display==='useraccount' && sessionIsValid"
                   v-bind:accountMenuScope="accountMenuScope"></AccountPage>
      <div class="session-expired-overlay" v-if="!sessionIsValid">
        <div class="page-style">
          <div class="loginBox">
            <div class="inner">
              <div class="signIn">
                <div class="top">
                  <div class="title">Session Expired</div>
                  <div class="subtitle">
                    This session has expired. You need to login to start a new session.
                  </div>
                  <div class="subtitle button-subtitle">
                    <div class="button is-fullwidth is-info" v-on:click="performLogout">Logout</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.body-bg-image-v870 {
  background-image: url("../assets/img/v870-mynt-05.jpg");
  background-size: cover;
}

.body-bg-image-61804 {
  background-image: url("../assets/img/61804.jpg");
  background-size: cover;
}

.body-bg-image-61802 {
  background-image: url("../assets/img/61802.jpg");
  background-size: cover;
}

.body-bg-image-rm373 {
  background-image: url("../assets/img/rm373batch15-bg-11.jpg");
  background-size: cover;
}

.body-bg-image-rm380 {
  background-image: url("../assets/img/rm380-01.jpg");
  background-size: cover;
}

.landing-page-bg {
  background: linear-gradient(135deg, #c2e8ff 0%, #ffeebf 100%);
}

.session-expired-overlay {
  z-index: 99;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: gray;
  opacity: 0.8;
}

.menu-list-container {
  margin: 0 5px;
}

.acctmenu-enter-active,
.acctmenu-leave-active {
  transition: opacity 0.5s ease;
}

.acctmenu-enter-from,
.acctmenu-leave-to {
  opacity: 0;
}

.account-menu {
  background-color: red;
  padding: 0;
  pointer-events: all;
}

.profile-open {
  height: 100%;
  padding: 0;
}

.search-input {
  margin: 0;
}

#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 5px;
  margin: 0;
  height: 60px;
  z-index: 30;
}

#bottomNav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  margin: 0;
  height: 60px;
  z-index: 30;
}

#bottomNavMenus {
  z-index: 50;
  right: 0;
  position: fixed;
  bottom: 60px;
  left: 0;
  margin: 0;
  pointer-events: none;
}

#bodySection {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  margin-top: 60px;
  margin-bottom: 60px;
}


@mixin box {
  box-shadow: 1px 1px 2px 1px #ccc;
}

@mixin field {
  border: 1px solid #aaa;
  height: 40px;
  padding: 10px;
  margin-top: 20px;
  border-radius: 5px;
  box-sizing: border-box;
}

.top {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.title {
  width: 100%;
  font-size: 1.8rem;
  margin-bottom: 10px;
  text-align: center;
}

.subtitle {
  .subtitle-action {
    color: green;
    font-weight: bold;
    cursor: pointer;
  }
}

.button-subtitle {
  width: 100%;
}

.page-style {
  background: linear-gradient(
      to bottom,
      rgba(96, 108, 136, 1) 0%,
      rgba(63, 76, 107, 1) 100%
  ) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
}

.loginBox {
  background: #fff;
  border-radius: 15px;
  max-width: 500px;
  padding: 25px 55px;
  animation: slideInTop 1s;
}

@keyframes slideInTop {
  from {
    opacity: 0;
    transform: translateY(-30%);
  }

  to {
    opacity: 100;
    transform: translateY(0%);
  }
}

@media screen and (min-width: 440px) {
  .loginBox {
    @include box;
  }
}

@media screen and (max-width: 440px) {
  html {
    background: #fff;
    align-items: start;
    justify-content: start;
  }

  .loginBox {
    padding: 25px 25px;
    max-width: 100vw;
  }
}


</style>
